// ADR-EK (defect ClickUp z8w5vqqetm) — คำอธิบายของอาจารย์ในรายวิชาโครงงาน/วิจัยคือ "รายการกลุ่ม"
// เขียนเป็น `<อะไรก็ได้>-<เลขกลุ่ม 2 หลัก>` คั่นด้วยจุลภาค เช่น `COE2026-08, COE2026-09`
// เอกสารรายงานภาระการสอน (doc_3) พิมพ์หนึ่งแถวต่อหนึ่งกลุ่ม โดยคิดหน่วยกิตเต็มเหมือน section หนึ่ง
//
// หนึ่งรายการกวาดหาเลขกลุ่มทุกตัวในรายการนั้น ข้อความต่อท้าย เช่น `COE2026-07 (633040600-1 …)`
// จึงยังอ่านได้ ส่วน `(?!\d)` กัน `COE2026-123` และรหัสนักศึกษาที่ลงท้ายด้วยเลขตรวจสอบหลักเดียว
//
// ต้องตรงกับ ProjectResearchSubjects::DescriptionSections ฝั่ง Rails เสมอ (รวมทั้งการตัดเลข 0 นำหน้า
// ซึ่งเป็นกติกาเดียวกับ SubjectScheduleGroup.normalize_section_value) — ที่นี่เตือนอย่างเดียว
// ไม่บล็อกการบันทึก ตัวตัดสินจริงอยู่ฝั่ง Rails
const SECTION_PATTERN = /-\s*(\d{2})(?!\d)/g;
const SEPARATOR_PATTERN = /[,\n\r]+/;

export function projectDescriptionTokens(description: string | null | undefined): string[] {
  return (description ?? '')
    .split(SEPARATOR_PATTERN)
    .map((token) => token.trim())
    .filter((token) => token.length > 0);
}

function sectionsInToken(token: string): string[] {
  return [...token.matchAll(SECTION_PATTERN)].map(([, section]) => String(Number(section)));
}

export function parseProjectDescriptionSections(description: string | null | undefined): string[] {
  return [...new Set(projectDescriptionTokens(description).flatMap(sectionsInToken))];
}

export function invalidProjectDescriptionTokens(description: string | null | undefined): string[] {
  return projectDescriptionTokens(description).filter((token) => sectionsInToken(token).length === 0);
}
